import styled from 'styled-components';

const RadioButtonWrapper = styled.div`
  width: 100%;

  @media screen and (min-width: 768px) {
    max-width: 48.5%;
  }

  input:checked + label {
    border: 1px solid ${({ theme }) => theme.custom.colors.brand};
    background: #fff7f4;
  }
`;

const RabioButton = styled.label`
  display: flex;
  align-items: center;
  width: 100%;
  height: 3rem;
  padding: 0rem 1rem 0.2rem 1rem;
  line-height: 1;
  background: white;
  color: ${({ theme }) => theme.custom.colors.black};
  border: 1px solid #b3b3b3;
  cursor: pointer;
  border-radius: 0.15rem;
  font-weight: normal;

  &:hover {
    border: 1px solid ${({ theme }) => theme.custom.colors.black};
  }
`;

const RadioInput = styled.input`
  opacity: 0;
  position: absolute;
`;

const RadioButton = ({ field: { name, value, onChange, onBlur }, id, label, onClickAction, ...props }) => {
  return (
    <RadioButtonWrapper>
      <RadioInput
        name={name}
        id={id}
        type="radio"
        checked={id === value}
        value={id}
        onChange={onChange}
        onBlur={onBlur}
        className={'radio-button'}
        {...props}
      />
      <RabioButton htmlFor={id} onClick={() => onClickAction(name, true, false)}>
        {label}
      </RabioButton>
    </RadioButtonWrapper>
  );
};

export default RadioButton;
